import React from 'react';
import { Box } from '@mui/material';
import useFieldHelper from './fieldHelper';
import { FieldProps } from '.';

const LENGUAGES = {
  RUSSIAN: 'Ru',
  POLISH: 'Pl',
  ENGLISH: 'En',
  OTHER: 'Un',
} as const;

const LanguageShortField = ({ ...props }: FieldProps) => {
  const { getValue } = useFieldHelper<keyof typeof LENGUAGES>({ ...props } as any);
  const language = getValue();

  return (
    <Box sx={{ border: '1px solid', borderColor: 'border.contrast', borderRadius: '5px' }}>
      {LENGUAGES[language] || LENGUAGES.OTHER}
    </Box>
  );
};

export default LanguageShortField;
